var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/send"
  }, /*#__PURE__*/React.createElement("g", {
    id: "send"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.79147 15.8333C4.79147 15.675 4.8498 15.5166 4.9748 15.3916L16.6415 3.72495C16.8831 3.48328 17.2831 3.48328 17.5248 3.72495C17.7665 3.96662 17.7665 4.36662 17.5248 4.60828L5.85814 16.2749C5.61647 16.5166 5.21647 16.5166 4.9748 16.2749C4.8498 16.1499 4.79147 15.9916 4.79147 15.8333Z",
    fill: "#1375B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.89967 4.16675C7.89967 3.82508 8.18301 3.54175 8.52467 3.54175L17.083 3.54175C17.4247 3.54175 17.708 3.82508 17.708 4.16675V12.7251C17.708 13.0667 17.4247 13.3501 17.083 13.3501C16.7413 13.3501 16.458 13.0667 16.458 12.7251V4.79175L8.52467 4.79175C8.18301 4.79175 7.89967 4.50841 7.89967 4.16675Z",
    fill: "#1375B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.1e1c7e3ba59cffc66e5cd4e4fa0a122d.svg";
export { ForwardRef as ReactComponent };